import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";
import DragIndicatorRoundedIcon from "@mui/icons-material/DragIndicatorRounded";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { DisplayOptionCardProps } from "../types";
import DisplayCard from "../Shared/DisplayCard";
import { alpha, Avatar, Grid, Paper, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
const DisplayOption = ({
  titleKey,
  descriptionKey,
  type,
  card,
  disabled = false,
  isSelected = false,
  onSelect
}: Partial<DisplayOptionCardProps>) => {
  const {
    t
  } = useTranslation();
  return <Card elevation={0} variant="outlined" sx={{
    borderColor: "border",
    height: "140px",
    borderRadius: 1
  }} data-sentry-element="Card" data-sentry-component="DisplayOption" data-sentry-source-file="DisplayOption.tsx">
      <CardActionArea data-cy={`integrationDisplayOption-${type}`} disabled={disabled} onClick={onSelect} data-selected={isSelected ? "" : undefined} sx={theme => ({
      height: "100%",
      "&[data-selected]": {
        outline: "1px solid",
        outlineColor: "primary.main",
        outlineOffset: "-1px",
        pointerEvents: "none",
        "& .left-grid": {
          outline: "1px solid",
          outlineColor: "primary.main",
          outlineOffset: "-1px",
          backgroundColor: alpha(theme.palette.primary.main, 0.04)
        }
      },
      "&:disabled": {
        opacity: 0.5
      }
    })} data-sentry-element="CardActionArea" data-sentry-source-file="DisplayOption.tsx">
        <CardContent sx={{
        height: "100%",
        p: 0
      }} data-sentry-element="CardContent" data-sentry-source-file="DisplayOption.tsx">
          <Grid container spacing={0} sx={{
          height: "100%"
        }} data-sentry-element="Grid" data-sentry-source-file="DisplayOption.tsx">
            <Grid width="240px" className="left-grid" data-sentry-element="Grid" data-sentry-source-file="DisplayOption.tsx">
              <Stack height="100%" direction="column" spacing={0.5} p={2} sx={{
              justifyContent: "center",
              alignItems: "flex-start"
            }} data-sentry-element="Stack" data-sentry-source-file="DisplayOption.tsx">
                {["shopify", "youtube", "mux", "classy"].includes(type) && <Avatar src={`/images/${type}Icon.svg`} variant="square" sizes="small" />}
                <Typography variant="h6" fontWeight={700} color="text.primary" data-sentry-element="Typography" data-sentry-source-file="DisplayOption.tsx">
                  {t(titleKey)}
                </Typography>
                <Typography variant="body2" fontWeight={400} color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="DisplayOption.tsx">
                  {t(descriptionKey)}
                </Typography>
              </Stack>
            </Grid>
            <Grid size="grow" container sx={{
            justifyContent: "center",
            alignItems: "center",
            px: 10,
            bgcolor: "grey.100"
          }} data-sentry-element="Grid" data-sentry-source-file="DisplayOption.tsx">
              <Paper elevation={0} variant="outlined" sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              borderColor: "border",
              borderRadius: 2
            }} data-sentry-element="Paper" data-sentry-source-file="DisplayOption.tsx">
                <DragIndicatorRoundedIcon color="action" fontSize="small" sx={{
                m: 0.5
              }} data-sentry-element="DragIndicatorRoundedIcon" data-sentry-source-file="DisplayOption.tsx" />
                <DisplayCard type={type} heading={card?.heading} subHeading={card?.subHeading} detail={card?.detail} thumbnail={card?.thumbnail} details={card?.details} data-sentry-element="DisplayCard" data-sentry-source-file="DisplayOption.tsx" />
                <MoreHorizIcon color="action" sx={{
                m: 1.5
              }} data-sentry-element="MoreHorizIcon" data-sentry-source-file="DisplayOption.tsx" />
              </Paper>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>;
};
export default DisplayOption;